module.exports = __webpack_public_path__ + "static/media/ZTC.8315ba34.pdf";